<template>
  <div id="downloadapp">
    <div id="download-up">
      <div id="download-tip">
        点击右上角按钮，然后在弹出的菜单中，点击在浏览器中打开，即可安装
      </div>
      <div class="download-title">建个会认证助手</div>
      <div class="download-describe">让实名认证不再繁琐</div>
      <img class="download-logo" src="../assets/img_download_valid.png" alt="">
      <button class="download-btn btn btn-success" type="button" @click="downloadApp" v-if="!isiOS">立即下载(.apk)</button>
      <button class="download-btn btn btn-default" type="button" disabled v-if="isiOS">iOS版即将上线</button>
    </div>
    <div id="download-copyright">@2018 杭州移木科技有限公司<span style="margin-left: 10px">浙ICP证B2-20180895</span></div>
  </div>
</template>

<script>
  let TWEEN = require("@tweenjs/tween.js");
  export default {
    name: "DownloadApp",
    data() {
      return {
        isiOS: false,
        isWechat: false,
        isShowDownloadTip: false
      };
    },

    methods: {
      downloadApp() {
        if (this.isWechat) {
          if (!this.isShowDownloadTip) {
            this.isShowDownloadTip = true;
            let style = {margin_top: -80};
            let style_end = {margin_top: 0};
            let tipEL = document.querySelector("#download-tip");
            new TWEEN.Tween(style)
              .to(style_end, 400)
              .easing(TWEEN.Easing.Linear.None)
              .onUpdate(function () {
                if (style) {
                  tipEL.style.setProperty("margin-top", style.margin_top + "px");
                }
              })
              .start();
          }
        } else {
          window.open(
            "http://download.yimulixin.cn/apks/creditgroup_0.0.1_Beta_1.apk?sign=dfba97552db3340104b0808d7a06772d&t=1542201346"
          );
        }
      }
    },

    mounted() {
      function animate(time) {
        requestAnimationFrame(animate);
        TWEEN.update(time);
      }

      requestAnimationFrame(animate);
      this.isiOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
      this.isWechat = /micromessenger/.test(navigator.userAgent.toLowerCase());
    }
  };
</script>

<style scoped>
  #downloadapp {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }

  #download-up {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #download-tip {
    margin-top: -80px;
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
    background: rgb(52, 52, 52);
    color: #7f7e7e;
    text-align: left;
  }

  .download-title {
    margin-top: 40px;
    font-size: 32px;
    color: #111;
    font-weight: 600;
  }

  .download-describe {
    margin-top: 10px;
    font-size: 24px;
    color: #555;
  }

  .download-logo {
    max-width: 360px;
  }

  .download-btn {
    margin-top: 10px;
    width: 300px;
    height: 45px;
    background-color: #13ca85;
    border: none;
    color: #fff;
    border-radius: 25px;
    box-shadow: none;
    font-size: 14px;
    font-family: "Tahoma", "宋体", "sans-serif";
  }

  .download-btn:disabled {
    background-color: #f4f4f4;
    color: #888;
  }

  #download-copyright {
    color: #999;
    font-size: 12px;
    margin: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/DownloadApp.vue